import React, { useEffect } from 'react';
import { useController, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { accountForms, GenForm, GenFormProps } from '~/pages/profile/components/AccountInformationForm';
import { getMember, useSpringBigStore, useUpdateMember } from '@springbig/shared';
import * as yup from 'yup';
import { useToast } from '~/hooks/toast';
import { Box } from 'native-base';
import { useGeneralStyles } from '~/shared/styles';

const emailSchema = yup.object().shape({
    email: yup
        .string()
        .required('email is required')
        .matches(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$/i, 'invalid email format')
        .trim(),
});

const zipSchema = yup.object().shape({
    zip: yup
        .string()
        .required('zip code is required')
        .trim()
        .matches(
            /^(\d{5}(?:[-\s]\d{4})?|[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d)$/,
            'invalid zip code format'
        ),
});

export const AccountForm = () => {

    const { member, setMember, walletId } = useSpringBigStore();
    const [formData, setFormData] = React.useState<GenFormProps['formKeys'][]>();
    const { mutate: updateMember, isLoading, data: memberUpdated } = useUpdateMember();
    const { successToast } = useToast();
    const gStyle = useGeneralStyles();

    const { control: controlEmail, handleSubmit: handleSubmitEmail, formState: { errors: errorsEmail }, setValue: setEmailValue } = useForm({
        resolver: yupResolver(emailSchema)
    });

    const { field: emailField } = useController({
        control: controlEmail,
        name: 'email',
    });

    const { control: controlZip, handleSubmit: handleSubmitZip, formState: { errors: errorsZip }, setValue: setZipValue } = useForm({
        resolver: yupResolver(zipSchema)
    });

    const { field: zipField } = useController({
        control: controlZip,
        name: 'zip',
        defaultValue: undefined
    });

    const formSchema = {
        email: {
            field: emailField,
            validatorError: errorsEmail?.email?.message,
            validator: handleSubmitEmail
        },
        zip: {
            field: zipField,
            validatorError: errorsZip?.zip?.message,
            validator: handleSubmitZip
        }
    };

    useEffect(() => {

        if (member) {
            const data_: GenFormProps['formKeys'][] = accountForms.map(el => {

                return {
                    ...el,
                    value: member[el.name] || undefined
                };
            });

            setFormData(data_);
            if (member.email) {

                setEmailValue('email', member.email);
            }

            if (member.zip) {

                setZipValue('zip', member.zip);
            }
        }
    }, [member]);

    useEffect(() => {

        if (memberUpdated) {
            handleMember(walletId || '');
            successToast('Member updated successfully');
        }

    }, [memberUpdated]);

    const handleMember = async (id: string) => {

        const member_ = id && await getMember({ walletId: id });

        if (member_) {
            setMember(member_);
        }

    };

    const handleSubmitValues = (values: GenFormProps['formKeys']) => {

        updateMember({
            member: {
                [values.name]: values.value
            }
        });
    };

    return (
        <>

            {
                formData && formData.map((el) => {

                    if (formSchema[el.name]) {
                        return (
                            <Box
                                px={4}
                                key={el.name}
                                bg={gStyle.section_background}
                            >
                                <GenForm
                                    field={formSchema[el.name].field}
                                    validatorError={formSchema[el.name].validatorError}
                                    validator={formSchema[el.name].validator}
                                    handleSubmitValues={handleSubmitValues}
                                    isLoading={isLoading}
                                    formKeys={el}
                                />
                            </Box>
                        );
                    }

                    return (
                        <Box
                            px={4}
                            key={el.name}
                            bg={gStyle.section_background}
                        >
                            <GenForm
                                handleSubmitValues={handleSubmitValues}
                                isLoading={isLoading}
                                formKeys={el}
                            />
                        </Box>
                    );
                })
            }
        </>
    );
};
